// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    RESEND_INVITE_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    resendInviteResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* resendInvite({ payload }) {
    try {
        const { id, entityName } = payload;

        let QUERY = ``;

        if (entityName === 'SubUser') {
            QUERY = `
                mutation resendInviteSubUser ($id: Int!) {
                    result: resendInviteSubUser (id: $id) 
                }
            `;
        }
        if (entityName === 'Account') {
            QUERY = `
                mutation resendInviteCompany ($id: Int!) {
                    result: resendInviteCompany (id: $id) 
                }
            `;
        }
        if (entityName === 'User') {
            QUERY = `
                mutation resendInviteUser ($id: Int!) {
                    result: resendInviteUser (id: $id) 
                }
            `;
        }

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: id,
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(resendInviteResult({ reset: data?.result || false }))


    } catch (exc) {
        yield put(resendInviteResult({ reset: false, error: exc }))
       // ExceptionManager(exc, 'Modules/accounts/views/components/resendInvite/redux/saga', 'resendInvite');
    }
}

function* watchMethods() {
    yield takeEvery(RESEND_INVITE_REQUEST, resendInvite);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}